import DescriptionModal from './DescriptionModal';

export default DescriptionModal;
